import NchLogoBase from "./FieldTypeBase/NchLogoBase";

const NchLogoInline = (props) => {
    return (

         <span className={`NchLogoInline ${props.field.class || ""} `}
            key={props.objectkey} 
            id={props.objectkey}>

            <NchLogoBase {...props} />

        </span>
    );
}
export default NchLogoInline;